/**
 * Return a list of keys that have a value in oldHashMap and a different non-empty value in newHashMap
 *
 * @method getCacheHashMapChanges
 * @param {Object} oldHashMap
 * @param {Object} newHashMap
 * @returns {Array} list of changed object keys
 */
const getCacheHashMapChanges = (oldHashMap, newHashMap) => {
  const changes = [];

  for (let key in oldHashMap) {
    if (oldHashMap[key] !== newHashMap[key] && newHashMap[key]) {
      changes.push(key);
    }
  }

  return changes;
};

export default getCacheHashMapChanges;
